import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchLunchMealsById = async (id) => {
  const response = await axios.get(
    `${WiMuleSQL}/api/LunchMenu/GetLunchMeal?id=${id}`
  );

  return response.data.data;
};

export const useGetLunchMealById = (id, enabled = true) =>
  useQuery({
    queryKey: ["LunchMealsById", id],
    queryFn: () => fetchLunchMealsById(id),
    enabled: enabled && !!id,
  });
